import { Navigate, Route, Routes } from "react-router-dom";
import { LoopPage } from "../../Looper/LoopPage/LoopPage";
import { MediaPage } from "../../MediaElement/MediaPage/MediaPage";
import "./Routing.css";
import { About } from "../About/About";
import { LoopTest } from "../../Looper/LoopTest/LoopTest";
import { LoopController } from "../../Looper/LoopController/LoopController";
export function Routing(): JSX.Element {
    return (
        <div className="Routing">
            <Routes>
                <Route path="/" element={<Navigate to="/home" />} />
                <Route path="/home" element={<LoopPage />} />
                <Route path="/home/controller" element={<LoopController />} />
                {/* <Route path="/home/test" element={<LoopTest />} /> */}
                <Route path="/media" element={<MediaPage/>} />
                <Route path="/media/:id" element={<MediaPage/>} />
                <Route path="/about" element={<About />} />
            </Routes>
			
        </div>
    );

}